import { getProducts } from "../controllers/company/products/ProductsMerchantController";
import { url } from "./apiBase";

const merchant = url + 'public/merchant/';

const publicRoutes = {
    merchant:{
        products:{
            getCategories: (merchantUUID) => `${merchant}${merchantUUID}/products/categories`,
            getProducts: (merchantUUID,categoryUUID) => `${merchant}${merchantUUID}/products${categoryUUID ? '?category_uuid='+categoryUUID : ''}`,
            //getProductsByCategory: (merchantUUID,categoryUUID) => `${merchant}${merchantUUID}/products/category/${categoryUUID}`,
            getProduct: (merchantUUID, productId) => `${merchant}${merchantUUID}/products/product/${productId}`,
        },
        
        categories: merchant + 'categories/', //completar con el uuid del merchant
        //products: url + 'public/merchants/products/',
    },
    booking:{
        availability: url + 'public/availability/slots',
        availabilityResource: (productId) => url + `public/availability/resources/${productId}`
    }
}

export default publicRoutes;